<div class="close" mat-dialog-close></div>
<img [ngStyle]="{'max-width': (screenWidth - (padding * 2))+'px', 'max-height': (screenHeight - (padding * 2))+'px'}" [src]="image + '?w=' + imageWidth + '&h=' + imageHeight" alt="">